export default {
  description: `İzmir İktisat Kongresi'nin kapanışında konuşan Kazım Karabekir Paşa, ülkenin içinde bulunduğu ekonomik durumu şu çarpıcı sözlerle özetlemiştir:<nl>"... Doğduğu günden itibaren çocuklarımızın boğazına yabancı sütü dökersek, yabancı bez ve pamuklarına sarıp yine yabancı beşiğine yatırırsak, ayağındaki patiğinden, başındaki mavi nazar boncuğuna ve elindeki teneke parçasına kadar yabancı malından yaparsak, Avrupa'da çakılmış dört tahtadan ibaret olan sandalyeler en ücra yerlere kadar girerse ve üstüne bir de kulaklarına, benim oğlum paşa olacak, gibi ninniler söyleyerek uyutucu tel kinler yaparsak, büyüdükten sonra doğaldır ki üzerinde ve çevresinde, artarak yabancı mallar bulunacak ve paralarımız akıp gidecektir..."`,
  title: `Buna göre Kazım Karabekir Paşa'nın savunduğu düşünce aşağıdakilerden hangisi olamaz?`,
  options: [
    {
      title: `Yerli malı kullanılmalı ve teşvik edilmeli.`,
      isTrue: false
    },
    {
      title: `Bağımsız ve millî bir ekonomi kurulmalı.`,
      isTrue: true
    },
    {
      title: `Türk malları sadece Türkiye'de kullanılmalı. `,
      isTrue: false
    },
    {
      title: `Yerli üretim artırılmalı.`,
      isTrue: false
    }
  ],
  id: 6
};



// WEBPACK FOOTER //
// ./src/assets/sorular/lgs/6.js